export const DUALITY_MODES = [
  {
    id: 'standard',
    description: 'Duality. Click to change',
    rollDescription: 'Roll 2d12',
    buttonType: 'black-white',
    hopeSides: 12,
    fearSides: 12,
  },
  {
    id: 'doomed',
    description: 'Doomed Duality. Click to change',
    rollDescription: 'Roll 1d20 Fear and 1d12 Hope',
    buttonType: 'duality-doomed',
    hopeSides: 12,
    fearSides: 20,
  },
  {
    id: 'blessed',
    description: 'Blessed Duality. Click to change',
    rollDescription: 'Roll 1d12 Fear and 1d20 Hope',
    buttonType: 'duality-blessed',
    hopeSides: 20,
    fearSides: 12,
  },
  {
    id: 'epic',
    description: 'Epic Duality. Click to change',
    rollDescription: 'Roll 2d20 (FUCK EM UP!)',
    buttonType: 'epic-gold',
    hopeSides: 20,
    fearSides: 20,
  },
];

export const getNextDualityMode = (currentMode) => {
  const currentIndex = DUALITY_MODES.findIndex((mode) => mode.id === currentMode);
  return DUALITY_MODES[(currentIndex + 1) % DUALITY_MODES.length].id;
};

export const buildDualityCommand = ({
  dualityMode = 'standard',
  dualityAdv,
  dualityDis,
  modPlus,
  modMinus,
}) => {
  const plus = Number(String(modPlus || '').trim() || 0);
  const minus = Number(String(modMinus || '').trim() || 0);
  const modifier =
    (Number.isFinite(plus) ? plus : 0) - (Number.isFinite(minus) ? minus : 0);

  let command = `Duality ${dualityMode}`;
  if (dualityAdv && !dualityDis) command += ' +Advantage';
  if (dualityDis && !dualityAdv) command += ' -Disadvantage';
  if (modifier) command += modifier > 0 ? ` +${modifier}` : ` ${modifier}`;
  return command;
};